import { ShieldCheck, HeartHandshake, Scale, FileLock2, Church } from "lucide-react";
import { useMeta } from "@/context/MetaContext";

const ITEMS = [
  { key: "two_track", icon: Church, title: "Two-track" },
  { key: "protected_leave", icon: HeartHandshake, title: "Protected leave" },
  { key: "at_will", icon: Scale, title: "At-will / developmental" },
  { key: "confidentiality", icon: FileLock2, title: "Confidentiality" },
];

export function ComplianceNotes({ only, compact = false }) {
  const { data: meta } = useMeta();
  if (!meta?.compliance) return null;
  const items = only ? ITEMS.filter((i) => only.includes(i.key)) : ITEMS;

  return (
    <div className={compact ? "space-y-2" : "grid gap-3 sm:grid-cols-2"} data-testid="compliance-notes">
      {items.map(({ key, icon: Icon, title }) => (
        <div key={key} className="flex items-start gap-2.5 rounded-xl bg-patria-sage/50 px-3.5 py-3">
          <Icon className="h-4 w-4 text-patria-green mt-0.5 shrink-0" />
          <div>
            <p className="text-xs font-semibold text-patria-greenDeep">{title}</p>
            <p className="text-xs text-patria-muted leading-relaxed">{meta.compliance[key]}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export function AntiRetaliationText() {
  const { data: meta } = useMeta();
  return <span>{meta?.compliance?.anti_retaliation}</span>;
}
